import { createApp } from "vue";
import "@mdi/font/css/materialdesignicons.min.css";

import App from "./App.vue";
import i18n from "./i18n";
import vuetify from "./plugins/vuetify";
import "./styles/main.css";

createApp(App).use(vuetify).use(i18n).mount("#app");
